import Component from 'vue-class-component';
import { Dictionary } from '../types/Dictionary';
import { PageDTO } from '../model/PageDTO';
import { pageComponentsByKey } from '../config/pages';
import { PageDataFetcher, BlockDataFetcher } from '../helpers/components';
import { MenuItemDTO } from '../model/MenuItemDTO';
import { blockComponentsByKey } from '../config/blocks';
import { BoIdMapping } from '../types/BoIdMapping';
import { BaseStore } from './base.store';

@Component
export class PageStore extends BaseStore {
	componentsPage: PageDTO = null;
	componentsPageIsLoaded: boolean = false;
	menu: MenuItemDTO[] = null;
	page: PageDTO = null;
	pageData: any = null;
	pageIsLoaded: boolean = false;
	boIdMapping: BoIdMapping = {};
	blockDataByTemplate: Dictionary<any> = {};

	getBlockData(blockTemplate: string) {
		return this.blockDataByTemplate[blockTemplate];
	}

	invalidatePage() {
		this.pageIsLoaded = false;
		this.page = null;
		this.pageData = null;
		this.boIdMapping = {};
		this.blockDataByTemplate = {};
	}

	async fetchComponentsPage() {
		this.componentsPage = await this.$pageService.fetchPage('components');
		await this.$store.fetchTexts('components', [], true);
		this.componentsPageIsLoaded = true;
	}

	async fetchPage(pageUrl: string, pageTemplate?: string) {
		this.invalidatePage();

		await this.fetchPageInternal(pageUrl, pageTemplate);

		await Promise.all([
			this.$store.fetchTexts('components', [this.boIdMapping]),
			this.$store.fetchTexts(pageUrl, [this.boIdMapping], true)
		]);

		this.pageIsLoaded = true;
	}

	async fetchBlock(blockTemplate: string) {
		const block = this.page.blocks.find(b => b.template === blockTemplate);
		const component = blockComponentsByKey[blockTemplate];

		if (!component) {
			console.warn(`Missing component for block '${blockTemplate}'.`);
			return;
		}

		const dataFetcher = (component as any).dataFetcher as BlockDataFetcher;

		if (!dataFetcher) {
			console.error(`Component of '${blockTemplate}' block must use @Block() decorator.`);
			return;
		}

		const data = await dataFetcher(this, block);

		this.blockDataByTemplate = {
			...this.blockDataByTemplate,
			[blockTemplate]: data
		};
	}

	protected async fetchPageInternal(pageUrl: string, pageTemplate?: string) {
		const [page, menu] = await Promise.all([
			this.$pageService.fetchPage(pageUrl),
			this.$pageService.fetchMenu(pageUrl),
		]);

		this.menu = menu;
		this.page = page;

		pageTemplate = pageTemplate || page.template;
		console.log(pageTemplate);

		const component = pageComponentsByKey[pageTemplate];

		if (!component) {
			console.warn(`Missing component for page template '${pageTemplate}'`);
			return;
		}

		const dataFetcher = (component as any).dataFetcher as PageDataFetcher;

		if (!dataFetcher) {
			console.error(`Component of '${pageUrl}' page must use @Page() decorator.`);
			return;
		}

		this.pageData = await dataFetcher(this);
		this.boIdMapping = this.pageData.boIdMapping;
	}
}
